import React, { useMemo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import DropDown from '../../cm/common/DropDown';
import useAlertLevelConfigs from '../../common/hooks/useAlertLevelConfig';

const DetailsFilters = ({
  className,
  filters,
  onChange,
  filterData,
  alertLevels
}) => {
  const { formatAlertLevelOptions } = useAlertLevelConfigs(alertLevels);

  const hitLevelOptions = useMemo(
    () => formatAlertLevelOptions(),
    [alertLevels]
  );

  return (
    <Container className={className}>
      <StyledDropDown
        label="Hit Level"
        placeholder={`Please select`}
        options={hitLevelOptions}
        allowClear
        value={filters?.hitLevel}
        onChange={(value) => onChange('hitLevel', value)}
      />
      <StyledDropDown
        label="Watchlist Name"
        placeholder={`Please select`}
        options={filterData?.nameOfWatchlist.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.nameOfWatchlist}
        onChange={(value) => onChange('nameOfWatchlist', value)}
      />
      <StyledDropDown
        label="Watchlist Category"
        placeholder={`Please select`}
        options={filterData?.watchlistCategory.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.watchlistCategory}
        onChange={(value) => onChange('watchlistCategory', value)}
      />
      <StyledDropDown
        label="Watchlist Sub-Category"
        placeholder={`Please select`}
        options={filterData?.watchlistSubCategory.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.watchlistSubCategory}
        onChange={(value) => onChange('watchlistSubCategory', value)}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  & > * {
    margin-right: 22px;
  }
`;
const StyledDropDown = styled(DropDown)`
  width: 300px;
`;

DetailsFilters.propTypes = {
  alertLevels: PropTypes.array,
  className: PropTypes.string,
  filters: PropTypes.object,
  filterData: PropTypes.object,
  onChange: PropTypes.func
};

export default DetailsFilters;
